import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedEmployeeRoute() {
  const isAuthenticated = localStorage.getItem('tester_token') !== null;
  return isAuthenticated ? <Outlet /> : <Navigate to="/mitarbeiter/login" replace />;
}
